const { html, url, routes } = window;

const menuItemTemplate = (child, addedMenuItemClasses = '', addedMenuItemAttr = '') => `
            <li role="presentation" class="ContextMenu-item ${addedMenuItemClasses}" ${addedMenuItemAttr}>
                ${child}
            </li>`;

export default ({
    isOwned,
    relatedTitlesPageUrl,
    id,
    rid,
    typeId,
    title,
    alignment,
    sampleHref,
    sampleText,
    historyActionLabel,
    historyActionText,
    historyEnabled,
    gaHistoryAction,
    seriesSearchUrl,
    hasMediaDoFormat,
}) => {
    const linkRole = 'menuitem';
    const sampleButtonLink = `<button class="ContextMenu-itemButton menu-option" data-href="${sampleHref}" data-media-id="${id}" data-title="${title}"
                            role="${linkRole}"
                            data-of-dropdown="more-actions-drop-${id}" data-type="${typeId}" media-do-format="${hasMediaDoFormat}"
                            tabindex="-1" 
                            aria-label="${html('cover.sampleLabel',{ sample: sampleText, title })}">
                                ${sampleText}
                        </button>`;

    const detailsLink = `<a tabindex="-1"
                            class="menu-option"
                            role="${linkRole}"
                            href="${url(routes.mediaId, {id,})}" 
                            aria-label="${html('viewDetailsAboutTitle', {title,})}">
                                ${html('viewDetails')}
                            </a>`;

    const seriesLink = `<a tabindex="-1" class="menu-option" href="${seriesSearchUrl}" role="${linkRole}">${html('viewSeries')}</a>`;

    const historyButtonLink = `<button class="ContextMenu-itemButton menu-option" 
                                tabindex="-1" role="${linkRole}" 
                                aria-label="${historyActionLabel}">
                                    ${historyActionText}
                                </button>`;

    const relatedLink = `<a tabindex="-1" 
                            class="menu-option"
                            role="${linkRole}"
                            href="${relatedTitlesPageUrl}" 
                            aria-label="${html('viewRelatedToTitle',{ title })}">
                                ${html('relatedTitles.relatedTitles')}
                        </a>`;

    return `
<div class="ContextMenu">
    <div tabindex="0" class="ContextMenu-button js-context-button" data-media-id="${id}"
         data-title="${title}"
         data-dropdown="context-menu-${id}-${rid}"
         data-options="align:${alignment}"
         aria-controls="context-menu-${id}-${rid}"
         aria-expanded="false"
         aria-label="${html('cover.titleInfo', { title })}"
         aria-haspopup="true"
         role="button"
         id="menu-button-${id}"
         >
        <i class="icon icon-more" aria-hidden="true"></i>
    </div>

    <ul id="context-menu-${id}-${rid}" 
        class="ContextMenu-drop js-context-drop f-dropdown"
        aria-labelledby="menu-button-${id}" 
        data-dropdown-content 
        aria-hidden="false" 
        role="menu" 
        tabindex="-1">
        ${
            isOwned &&
            sampleHref !== '' &&
            !(window.OverDrive.isTolinoDevice && typeId === 'audiobook')
                ? menuItemTemplate(sampleButtonLink, 'read-sample')
                : ''
        }
        ${menuItemTemplate(detailsLink)}
        ${
            seriesSearchUrl && seriesSearchUrl !== ''
                ? menuItemTemplate(seriesLink)
                : ''
        }
        ${
            historyEnabled &&
            !window.featureManager.isEnabled('sampleOnlyMode')
                ? menuItemTemplate(historyButtonLink, 'js-historyAction', `data-ga-action="${gaHistoryAction}" data-media-id="${id}"`)
                : ''
        }
        ${menuItemTemplate(relatedLink)}
    </ul>
</div>`;
};
